module.exports = __webpack_public_path__ + "img/form.79d9e4ae.png";